import { useState, useEffect } from 'react'
import { useTimer } from '../hooks'
import { formatTime } from '../lib/utils'

export default function BlockTimer({ block, initialSeconds = 0, onComplete }) {
  const { seconds, isRunning, start, pause, reset } = useTimer(initialSeconds)
  const [subject, setSubject] = useState(block?.subject || '')
  const [focusScore, setFocusScore] = useState(0)
  const [showConfirm, setShowConfirm] = useState(false)

  // 从父组件同步 block 状态
  useEffect(() => {
    if (block?.start_time && !block?.end_time) {
      const start = new Date(block.start_time)
      const now = new Date()
      const elapsed = Math.floor((now - start) / 1000)
      if (elapsed > 0) {
        // 恢复运行中的计时
        for (let i = 0; i < elapsed; i++) setSeconds(s => s + 1)
        start()
      }
    }
  }, [block])

  const handleStart = () => {
    start()
    onComplete?.({ action: 'start', blockId: block.id })
  }

  const handleEnd = () => {
    if (seconds < 60) {
      // 少于1分钟直接结束
      finish()
    } else {
      setShowConfirm(true)
    }
  }

  const finish = () => {
    pause()
    setShowConfirm(false)
    onComplete?.({
      action: 'end',
      blockId: block.id,
      duration: seconds,
      subject,
      focusScore,
    })
  }

  const isActive = isRunning
  const elapsedMin = Math.floor(seconds / 60)

  return (
    <div className={`card p-4 transition-all ${isActive ? 'ring-2 ring-accent' : ''}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="font-mono text-sm text-ink-500 dark:text-ink-300">{block.name}</span>
        {subject && (
          <span className="text-xs px-2 py-0.5 rounded-full bg-ink-100 dark:bg-ink-400">{subject}</span>
        )}
      </div>

      <div className="text-3xl font-mono font-bold text-center my-3">
        {formatTime(seconds)}
      </div>

      {!isActive && elapsedMin === 0 && (
        <button onClick={handleStart} className="btn-primary w-full">
          开始
        </button>
      )}

      {isActive && (
        <>
          <div className="flex gap-2 mb-3">
            <select
              value={subject}
              onChange={e => setSubject(e.target.value)}
              className="input flex-1 text-sm"
            >
              <option value="">科目</option>
              <option value="数学">数学</option>
              <option value="语文">语文</option>
              <option value="英语">英语</option>
              <option value="政治">政治</option>
              <option value="物理">物理</option>
              <option value="化学">化学</option>
            </select>
          </div>
          <button onClick={handleEnd} className="btn-secondary w-full">
            结束
          </button>
        </>
      )}

      {!isActive && elapsedMin > 0 && (
        <button onClick={() => { start() }} className="btn-ghost w-full">
          继续
        </button>
      )}

      {showConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="card p-6 max-w-sm w-full mx-4">
            <h3 className="text-lg font-bold mb-2">这次真的在学吗？</h3>
            <p className="text-sm text-ink-500 dark:text-ink-300 mb-4">
              时段 {block.name} 学习了 {elapsedMin} 分钟
            </p>
            <div className="mb-4">
              <label className="label block mb-1">专注度自评 (1-10)</label>
              <input
                type="range"
                min="1"
                max="10"
                value={focusScore || 5}
                onChange={e => setFocusScore(Number(e.target.value))}
                className="w-full"
              />
              <div className="text-center text-sm mt-1">{focusScore || 5}/10</div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setShowConfirm(false)} className="btn-ghost flex-1">
                取消
              </button>
              <button onClick={finish} className="btn-primary flex-1">
                确认结束
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
